import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { UiCommonModule, RegHubDateAdapter, REG_HUB_DATE_FORMATS } from 'reg-hub-common';
import { environment } from '../../environments/environment';
import { SharedModule } from 'projects/reg-hub-admin/src/app/shared/shared.module';
import { BundlesRoutingModule } from './bundles-routing.module';
import { BundlesFilterComponent } from './bundle-filter/bundles-filter.component';
import { BundlesListComponent } from './bundles-list/bundles-list.component';
import { AddBundlesComponent } from './add-bundles/add-bundles.component';
import { BatchesFilterComponent } from './batches-filter/batches-filter.component';
import { BatchesListComponent } from './batches-list/batches-list.component';
import { BatchComponent } from './batch/batch.component';
import { BundleComponent } from './bundle/bundle.component';
import { DraftBatchComponent } from './draft-batch/draft-batch.component';
import { BatchOrdersFilterComponent } from './batch-orders-filter/batch-orders-filter.component';
import { BatchOrdersListComponent } from './batch-orders-list/batch-orders-list.component';
import { BundleOrdersFilterComponent } from './bundle-orders-filter/bundle-orders-filter.component';
import { BundleOrdersListComponent } from './bundle-orders-list/bundle-orders-list.component';
import { BatchErrorsPopupComponent } from './batch-errors-popup/batch-errors-popup.component';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
    declarations: [
      BundlesFilterComponent,
      BundlesListComponent,
      AddBundlesComponent,
      BundleComponent,
      BatchesFilterComponent,
      BatchesListComponent,
      BatchComponent,
      DraftBatchComponent,
      BatchOrdersFilterComponent,
      BatchOrdersListComponent,
      BundleOrdersFilterComponent,
      BundleOrdersListComponent,
      BatchErrorsPopupComponent
    ],
    imports: [
        TranslocoModule,
        CommonModule,
        SharedModule,
        UiCommonModule.forRoot({ rootUrl: environment.urlAddress, batchRootURL: environment.batchUrlAddress, consortiumRootURL: environment.consortiumUrlAddress }),
        BundlesRoutingModule
    ],
    providers: [
      { provide: DateAdapter, useClass: RegHubDateAdapter},
      { provide: MAT_DATE_FORMATS, useValue: REG_HUB_DATE_FORMATS},
    ]
})
export class BundlesModule { }